<section class="hero wave-bg">
  <div class="container hero-content">
    <div class="hero-text">
      <div style="color: var(--brand); font-weight: 700; margin-bottom: 1rem; text-transform: uppercase; font-size: 0.9rem;">Urgence Obsolescence Technique</div>
      <h1>
        AngularJS est obsolète. 
        <span class="accent"> Ne laissez pas votre business s'éteindre avec lui.</span>
      </h1>
      <p class="hero-description">
        Les failles de sécurité se multiplient, les talents s'échappent et les performances de vos interfaces chutent. La dette technique AngularJS pèse chaque jour plus lourd sur votre ROI. Nos experts seniors migrent vos systèmes vers Angular (v19+), **sans aucune interruption de service.**
      </p>
      <div class="cta-row">
        <a 
          href="https://cal.mesh-box.fr/ogirodin/30min"
          target="_blank"
          rel="noopener"
          class="button primary large" 
        >
          Planifier mon Audit de Migration
        </a>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="container max-w-4xl">
    <h2>Pourquoi la migration AngularJS vers Angular est impérative</h2>
    <p class="mb-8">
      Utiliser une application en AngularJS en 2026, c'est comme piloter un avion dont les pièces ne sont plus fabriquées. Les risques pour la continuité de votre activité sont réels et immédiats.
    </p>
    <div class="grid-2" style="text-align: left;">
      <div class="card p-6 border-l-4 border-red-500">
        <h3 class="text-lg font-bold mb-2">🔴 Risques de Sécurité Majeurs</h3>
        <p class="text-sm">Le framework n'est plus maintenu. Les vulnérabilités découvertes aujourd'hui resteront à jamais ouvertes. Votre conformité RGPD est directement menacée par l'absence de patchs.</p>
      </div>
      <div class="card p-6 border-l-4 border-red-500">
        <h3 class="text-lg font-bold mb-2">🔴 Fuite des Compétences</h3>
        <p class="text-sm">Les développeurs experts en AngularJS disparaissent du marché. Recruter pour maintenir du legacy est devenu un gouffre financier sans aucune perspective d'innovation.</p>
      </div>
      <div class="card p-6 border-l-4 border-red-500">
        <h3 class="text-lg font-bold mb-2">🔴 Paralysie de l'Innovation</h3>
        <p class="text-sm">Il est techniquement impossible d'intégrer les dernières avancées comme les Progressive Web Apps (PWA), les Web Workers performants ou l'IA générative sur une base AngularJS.</p>
      </div>
      <div class="card p-6 border-l-4 border-red-500">
        <h3 class="text-lg font-bold mb-2">🔴 Performance & UX Dégradées</h3>
        <p class="text-sm">Le moteur de rendu "two-way data binding" d'AngularJS est incapable de rivaliser avec la rapidité des frameworks modernes. Vos utilisateurs subissent des lenteurs qui impactent vos conversions.</p>
      </div>
    </div>
  </div>
</section>

<section class="section alt">
  <div class="container max-w-5xl">
    <h2>Notre Stratégie : Le Pattern Strangler Fig (Migration Progressive)</h2>
    <p class="max-w-3xl mx-auto mb-12 text-lg">
      Oubliez les projets de réécriture interminables et risqués de type "Big Bang". Chez Mesh Box, nous privilégions une approche chirurgicale qui permet de moderniser votre frontend brique par brique.
    </p>
    <div class="grid-3 gap-8 mb-12">
      <div class="card reveal p-8">
        <div class="text-4xl text-brand font-bold mb-4">01</div>
        <h4>Audit & Cartographie</h4>
        <p class="text-sm">Nous analysons vos composants existants et isolons les briques critiques pour établir une roadmap de migration priorisée par la valeur métier.</p>
      </div>
      <div class="card reveal p-8">
        <div class="text-4xl text-brand font-bold mb-4">02</div>
        <h4>Architecture Hybride</h4>
        <p class="text-sm">Mise en place de la bibliothèque <strong>ngUpgrade</strong>. Vos composants modernes et legacy cohabitent parfaitement pendant la phase de transition.</p>
      </div>
      <div class="card reveal p-8">
        <div class="text-4xl text-brand font-bold mb-4">03</div>
        <h4>Migration Continue</h4>
        <p class="text-sm">Migration itérative des modules (Components, Services, Routing). Vous bénéficiez de gains de performance visibles dès la première semaine.</p>
      </div>
    </div>
    
    <div class="bg-card p-8 rounded-xl border border-brand/20 shadow-lg">
      <h3 class="mb-4">Bénéfices d'une migration réussie vers Angular Moderne</h3>
      <div class="grid-2 text-left text-sm gap-4">
        <div class="flex items-center gap-3">
          <span class="text-brand">⚡</span>
          <span>Gain de 50% à 70% sur les Core Web Vitals (LCP, INP).</span>
        </div>
        <div class="flex items-center gap-3">
          <span class="text-brand">🛡️</span>
          <span>Sécurisation totale et conformité aux standards actuels.</span>
        </div>
        <div class="flex items-center gap-3">
          <span class="text-brand">🎯</span>
          <span>Maintenance simplifiée grâce au typage strict TypeScript.</span>
        </div>
        <div class="flex items-center gap-3">
          <span class="text-brand">📈</span>
          <span>Scalabilité pour accompagner votre croissance utilisateur.</span>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section">
    <div class="container max-w-4xl text-center">
        <h2>Expertise et Sérénité Opérationnelle</h2>
        <p class="text-lg mb-12">
            Chez Mesh Box, nous avons accompagné de nombreux groupes dans le sauvetage de leurs plateformes stratégiques, transformant des applications AngularJS obsolètes en solutions Angular véloces.
        </p>
        <div class="grid-2 gap-8 items-center mb-12">
          <div class="card p-10 bg-panel text-left italic border-l-4 border-brand">
              <p>"Grâce à leur maîtrise technique, nous avons pu migrer notre outil métier tout en continuant à délivrer nos fonctionnalités critiques. Le passage vers Angular a drastiquement réduit nos bugs en production."</p>
              <footer class="mt-4 not-italic">
                <strong class="block">— CTO, Grand Compte Retail</strong>
                <span class="text-xs text-muted">Migration effectuée en 6 mois sur 150 composants.</span>
              </footer>
          </div>
          <div>
            <app-cii-badge variant="hero" />
            <p class="mt-4 text-sm text-muted">
              Le développement innovant lié à la migration vers de nouveaux frameworks est éligible au Crédit Impôt Innovation (CII).
            </p>
          </div>
        </div>
        <p class="text-sm text-muted">Besoin de plus d'informations techniques ? Consultez le <a href="https://angular.dev/guide/upgrade" target="_blank" rel="noopener noreferrer" class="underline">guide officiel ngUpgrade</a>.</p>
    </div>
</section>

<section class="section cta-final alt">
  <div class="container max-w-4xl text-center">
    <h2>Dites adieu au code Legacy, accueillez l'innovation</h2>
    <p class="text-lg mb-8">Ne laissez pas une technologie dépassée dicter vos limites métier. Discutons de votre plan de migration dès aujourd'hui.</p>
    <a 
      href="https://cal.mesh-box.fr/ogirodin/30min"
      target="_blank"
      rel="noopener"
      class="button primary large" 
    >
      Lancer mon Diagnostic Technique
    </a>
  </div>
</section>